import React from "react"
import Layout from "../components/Layout"
import StyledHero from "../components/StyledHero"
import { graphql } from "gatsby"
import Events from "../components/Events/Events"
import SEO from "../components/SEO"

const events = ({ data }) => {
  return (
    <Layout>
      <SEO title="events" />
      <StyledHero img={data.bcg.childImageSharp.fluid} />
      <Events />
    </Layout>
  )
}
export const query = graphql`
  query {
    bcg: file(relativePath: { eq: "defaultBcg.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 1600) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default events
